import React, { useLayoutEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './PaymentAddExternal.css';
import { IonButton, IonContent } from '@ionic/react';
import { getAppError } from '../../utils/messages';
import { useToaster } from '../../hooks/useToaster';

type PaymentAddExternalProps = {
  paymentToken: string;
  validFields: {
    ccnumber?: boolean | null;
    ccexp?: boolean | null;
    cvv?: boolean | null;
  };
  collectJs: any | null;
  setIsLoading: (e: boolean) => void;
};

export default function PaymentAddExternal({
  validFields = { ccnumber: false, ccexp: false, cvv: false },
  collectJs = {},
  setIsLoading,
}: PaymentAddExternalProps) {
  const [t] = useTranslation('global');
  const [present] = useToaster();

  const isValid = useMemo<'' | 'btn-disabled'>(() => {
    return validFields.ccnumber && validFields.ccexp && validFields.cvv
      ? ''
      : 'btn-disabled';
  }, [validFields.ccnumber, validFields.ccexp, validFields.cvv]);

  useLayoutEffect(() => {
    if (collectJs) {
      collectJs.configure();
    }
  }, [collectJs]);

  const isSubmitDisabled = useMemo(() => {
    const fields: Array<keyof typeof validFields> = [
      'ccnumber',
      'ccexp',
      'cvv',
    ];
    for (const field of fields) {
      if (validFields[field] === null) {
        return true;
      }
    }
    return false;
  }, [validFields]);

  const handleSave = () => {
    if (!validFields.ccnumber) {
      return present(getAppError(t('payments.errorCcnumber')));
    }
    if (!validFields.ccexp) {
      return present(getAppError(t('payments.errorCcexp')));
    }
    if (!validFields.cvv) {
      return present(getAppError(t('payments.errorCvv')));
    }

    setIsLoading(true);
    collectJs.startPaymentRequest();
  };

  return (
    <IonContent fullscreen className="ion-padding default-content">
      <p className="pb-1 instructions ion-text-center">
        {t('payments.instruct')}
      </p>
      <div id="ccnumber" />
      <div id="ccexp" />
      <div id="cvv" />
      <div className="pt-3 ion-text-center">
        <IonButton
          className={'btn-default btn-wide-80 ' + isValid}
          onClick={handleSave}
          //disabled={isSubmitDisabled}
        >
          {t('payments.save')}
        </IonButton>
      </div>
    </IonContent>
  );
}
